import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { IAuthContext } from '../context/auth/auth-context';
import { RouteComponentProps } from 'react-router-dom';
import { Table, InputGroup, FormControl, Row, Col, OverlayTrigger } from 'react-bootstrap';
import styled from 'styled-components';
import { Search } from 'react-feather';
import LoadingButton from '../components/LoadingButton';
import { toast } from 'react-toastify';
import SearchPagination from '../components/search/SearchPagination';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import axios from 'axios';
import ReactTooltip from 'react-tooltip';
import { API_BASE_URL } from '../util/api.util';
import { getStorage, ref } from 'firebase/storage';
import ReactGA from 'react-ga4';

const Transition = React.forwardRef(function transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  innerRef: React.Ref<unknown>
) {
  return <Slide direction="up" ref={innerRef} {...props} />;
});

const PageRoot = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ContentInner = styled.div`
  margin: 4em 5em;
  box-sizing: border-box;
`;


const GlassCard = styled.div`
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  margin-bottom: 1.25rem;

  .table-container {
    overflow: auto;
    max-height: 420px;
  }
`;

const THead = styled.thead`
  background: #0f172a;
  color: #f8fafc;
  text-align: center;
  height: 60px;
`;
const TH = styled.th`
  vertical-align: top !important;
  border-color: #374151 !important;
  font-weight: 600;
  color: #f8fafc;
`;
const TD = styled.td`
  color: #f8fafc;
  border-color: #374151 !important;

  em,
  strong,
  b {
    font-style: normal;
    font-weight: 700;
    color: #f8fafc;
  }
`;
const SearchBarInputContainer = styled.form`
  width: 100%;
  margin-bottom: 1rem;

  .input-group {
    background: rgba(15, 23, 42, 0.65);
    border: 1px solid rgba(148, 163, 184, 0.35);
    border-radius: 10px;
    overflow: hidden;
  }

  .form-control {
    background: transparent;
    border: 0;
    color: #e2e8f0;
    font-size: 0.95rem;
  }

  .form-control::placeholder {
    color: #94a3b8;
  }

  .form-control:focus {
    box-shadow: none;
    background: transparent;
    color: #f8fafc;
  }

  .input-group-append .btn {
    background: #3aefb8 !important;
    border: none !important;
    color: #000 !important;
    border-radius: 8px !important;
    margin: 4px;
    min-width: 42px;
    min-height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(52, 211, 153, 0.28);
    transition: background 0.15s ease, transform 0.12s ease;
  }

  .input-group-append .btn:hover,
  .input-group-append .btn:focus,
  .input-group-append .btn:active {
    background: #63f4ca !important;
    color: #000 !important;
    box-shadow: 0 12px 28px rgba(94, 234, 212, 0.32) !important;
    transform: translateY(-1px);
  }
`;
const DownloadTD = styled.td`
  cursor: pointer;
  text-align: center;
  color: #34d399;
  font-weight: 500;
  border-color: rgba(148, 163, 184, 0.2) !important;
  background: rgba(15, 23, 42, 0.45);

  &:hover {
    color: #6ee7b7;
  }
`;

const PaginationWrap = styled.div`
  margin-top: 0.75rem;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;

  .pagination {
    margin-bottom: 0;
    justify-content: space-between !important;
  }

  .page-link {
    min-width: 48px;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: rgba(3, 7, 18, 0.72) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    color: #e2e8f0 !important;
    border-radius: 2px;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    box-shadow: none;
  }

  .page-item.disabled .page-link {
    background: rgba(3, 7, 18, 0.72) !important;
    border-color: rgba(255, 255, 255, 0.08) !important;
    color: #64748b !important;
    opacity: 1;
  }

  div {
    color: #7c8b9f !important;
  }
`;

const doStorageDownload = R.contains(R.__, ['tceq_novell']);
const getStorageRef = R.cond<string, ReturnType<typeof ref> | null>([
  [R.equals('tceq_novell'), R.always(ref(getStorage(), `gs://${process.env.REACT_APP_STORAGE_BUCKET_NOVELL}`))],
  [R.T, R.always(null)],
]);

const CorrectiveTracker: React.FC<
  RouteComponentProps<any> & {
    context: IAuthContext;
  }
> = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  // const [onload, setOnload] = useState(true);
  const [searchResult, setSearchResult] = useState<any>(null);
  const [downloadTriggers, setDownloadTriggers] = useState<string[]>([]);
  const [open, setOpen] = React.useState(false);
  const [queryText, setQueryText] = useState('');

  const doTextSearch = (text: string = '', from = 0) => {
    setIsLoading(true);
    const requestBody: any = {};
    requestBody.records_num_from = from;
    requestBody.records_num_show = 10;
    requestBody.keyword = text;
    axios
      .get(
        API_BASE_URL + '/CorrectiveActionTracker?records_num_from=' +
          from +
          '&records_num_show=30&keyword=' +
          text,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        }
      )
      .then((response) => {
        setSearchResult(response.data);
        if (from === 0) {
          setOpen(true);
          setTimeout(handleClose, 4000);
        }
      })
      .finally(() => setIsLoading(false));
  };
  const handleClose = () => {
    setOpen(false);
  };
  // if (onload === true) {
  //   setOnload(false);
  //   doTextSearch(queryText);
  // }

  useEffect(() => {
    if(window.top !== window.self) {
      const query = new URLSearchParams(props.location.search);
      const rn: any = query.get('rn');
      setQueryText(rn);
      doTextSearch(rn);
    } else {
      doTextSearch(queryText);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryText]);

  return (
    <PageRoot>
      <ContentInner>
        <p className="kicker">Corrective Tracker</p>
        <h1 className="validator-title">Corrective <em className="em-css">tracking</em></h1>
        <h2 className="validator-subtitle">Search compliance actions by entity and event history</h2>

        <GlassCard>
          <Row>
            <Col>
              <SearchBarInputContainer
                onSubmit={(e) => {
                  e.preventDefault();
                  // Track analytics event for the search query
                  ReactGA.event({
                    category: 'Search',
                    action: 'Corrective Tracker Query',
                    label: queryText // Optional: log the value the user typed
                  });
                  doTextSearch(queryText);
                }}
              >
                <InputGroup>
                  <FormControl
                    onChange={(e: any) => setQueryText(e.target.value)}
                    placeholder="Search company or entity number"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={queryText}
                  />
                  <InputGroup.Append>
                    <LoadingButton isLoading={isLoading || false} >
                      <Search />
                    </LoadingButton>
                  </InputGroup.Append>
                </InputGroup>
              </SearchBarInputContainer>
            </Col>
          </Row>

          {searchResult !== null && (
            <>
              <div className="table-container">
                <Table bordered hover variant="dark" className="cmn-corrective-tracker-dark-table">
                  <THead>
                    <tr>
                      <TH style={{ width: '10%' }}>Date</TH>
                      <TH style={{ width: '10%' }}>Entity Name</TH>
                      <TH style={{ width: '10%' }}>Event</TH>
                      <TH>Corrective Action</TH>
                      <TH style={{ width: '7%' }}>Doc</TH>
                    </tr>
                  </THead>
                  <tbody>
                    {searchResult.total_records > 0 &&
                      searchResult.data.map((record: any, index: any) => (
                        <tr key={index}>
                          <TD>{record.date}</TD>
                          <TD>
                            <OverlayTrigger
                              placement="bottom"
                              key={index}
                              overlay={<ReactTooltip effect="solid" />}
                            >
                              <span
                                data-tip={
                                  record.entity_number
                                }
                              >{record.entity_name}</span>
                            </OverlayTrigger>
                          </TD>
                          <TD>{record.event}</TD>
                          <TD
                            dangerouslySetInnerHTML={{
                              __html: record.corrective_action
                                ? record.corrective_action.replace(`/[^\x00-\x7F]/g`, '')
                                : '<h3>No Preview Available</h3>',
                            }}
                          />
                          <OverlayTrigger
                              placement="bottom"
                              key={index}
                              overlay={<ReactTooltip effect="solid" />}
                            >
                          <DownloadTD
                            onClick={() => {
                              if (doStorageDownload(record.doc_url)) {
                                const storageRef = getStorageRef(record.entitySource);
                                if (R.isNil(storageRef)) {
                                  return toast.error(`Oops, could not find the file.`);
                                }
                                setDownloadTriggers(R.append(index + 1, downloadTriggers));
                                return (storageRef as any)
                                  .ref(record.fileName)
                                  .getDownloadURL()
                                  .then((url: string) => window.open(url, '_blank', 'noopener,noreferrer'))
                                  .catch((err: any) => toast.error(err.message))
                                  .finally(() => setDownloadTriggers(R.without([index + 1], downloadTriggers)));
                              }
                              if (!record.doc_url) {
                                return toast.warn(
                                  <span>
                                    No associated file was found for the content id <b>{record.contentId}</b>
                                  </span>
                                );
                              }
                              window.open(record.doc_url, '_blank');
                            }}
                          >
                          <span data-tip="Click to download">Link</span>
                          </DownloadTD>
                          </OverlayTrigger>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
              <PaginationWrap>
                <SearchPagination
                  isDisabled={false}
                  facilitiesCount={0}
                  isFirstPage={(searchResult && searchResult.records_num_from === 0) || false}
                  isLastPage={
                    (searchResult &&
                      searchResult.records_num_from + searchResult.records_num_show >= searchResult.total_records) ||
                    false
                  }
                  totalRecords={(searchResult && searchResult.total_records) || 0}
                  onPreviousClick={() => {
                    if (!searchResult) {
                      return;
                    }
                    const currentFrom = searchResult.records_num_from;
                    const currentSize = searchResult.records_num_show;
                    setIsLoading(true);
                    return doTextSearch(queryText, currentFrom - currentSize);
                  }}
                  onNextClick={() => {
                    if (!searchResult) {
                      return;
                    }
                    const currentFrom = searchResult.records_num_from;
                    const currentSize = searchResult.records_num_show;
                    return doTextSearch(queryText, currentFrom + currentSize);
                  }}
                />
              </PaginationWrap>
            </>
          )}
        </GlassCard>
      </ContentInner>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <img src="/icon/action-tracker.png" alt="Satellite App" width="220" />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </PageRoot>
  );
};

export default CorrectiveTracker;
